import React from 'react';

import Overview from '../../images/overview.svg';

export const OverviewLogo = () => {
  return <img height="18" src={Overview} alt="Overview logo" />;
};
